import React from 'react'

import './Tooltip.scss'

const Tooltip = ({ text, tooltipText, onClick, position = 'bottom' }) => {
    const _onClick = evt => {
        if (onClick) {
            onClick(evt)
        }
    }

    if (!tooltipText || !text) {
        return null
    }
    return (
        <span className={`tooltip ${onClick ? 'clickable' : ''}`} onClick={_onClick}>
            {text}
            <span className={`tooltip__box-wrapper tooltip-${position}`}>
                {typeof tooltipText === 'string' ? <span className="tooltip__box">{tooltipText}</span> : tooltipText}
            </span>
        </span>
    )
}
export default Tooltip
